import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { AuthLayout } from '@/components/AuthLayout';
import { Logo } from '@/components/Logo';
import { colors } from '@/styles/colors';

export default function MaintenanceScreen() {
  return (
    <AuthLayout>
      <View style={styles.container}>
        <Logo />
        
        <View style={styles.content}>
          <Text style={styles.emoji}>🩺</Text>
          
          <Text style={styles.heading}>We'll be right back!</Text>
          
          <Text style={styles.message}>
            We're taking a quick break to make your Vida Health experience even better. 
            Our team is working hard to get everything back up and running.
          </Text>
          
          <Text style={styles.subMessage}>
            Thank you for your patience! Your health and wellness journey is important to us, 
            and we'll be back to support you very soon.
          </Text>
          
        </View>
      </View>
    </AuthLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
  },
  content: {
    width: '100%',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  emoji: {
    fontSize: 64,
    marginBottom: 24,
  },
  heading: {
    fontSize: 40,
    lineHeight: 48,
    fontWeight: '700',
    color: colors.textPrimary,
    marginBottom: 24,
    textAlign: 'center',
  },
  message: {
    fontSize: 18,
    lineHeight: 28,
    color: colors.textPrimary,
    marginBottom: 20,
    textAlign: 'center',
    maxWidth: 500,
  },
  subMessage: {
    fontSize: 16,
    lineHeight: 24,
    color: colors.textSecondary,
    marginBottom: 40,
    textAlign: 'center',
    maxWidth: 500,
  },
});
